import { useEffect, useState } from "react";
import api from "../api/api";

export default function Users() {
  const [users, setUsers] = useState([]);

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });

  // ✅ Get logged-in user
  const loggedInUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get("/users");
    setUsers(res.data || []);
  };

  const create = async () => {
    const { name, email, password } = form;

    if (!name || !email || !password) {
      return alert("All fields required");
    }

    try {
      await api.post("/users/create", {
  name,
  email,
  password,
  role: "admin",   // new user role
  created_by: loggedInUser.role   // 👈 IMPORTANT
});

      alert("User Created");

      setForm({
        name: "",
        email: "",
        password: "",
      });

      load();
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ UPDATED REMOVE (with role)
  const remove = async (id) => {
    try {
      await api.delete(`/user/${id}`, {
        data: {
          role: loggedInUser?.role,
        },
      });

      load();
    } catch (err) {
      console.log(err);
      alert("Only Super Admin can delete");
    }
  };

  return (
    <div className="min-h-screen -mt-10">

      <h2 className="text-4xl text-[#030244] font-semibold text-center mb-8">
        Users
      </h2>

      {/* FORM CARD */}
      <div className="max-w-md mx-auto bg-white shadow-lg p-8 rounded-xl border">

        <div className="flex flex-col gap-4">

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Name"
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
          />

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Email"
            value={form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
          />

          <input
            type="password"
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Password"
            value={form.password}
            onChange={(e) =>
              setForm({ ...form, password: e.target.value })
            }
          />

        </div>

        <div className="flex justify-center mt-6">
          <button
            onClick={create}
            className="bg-[#030244] hover:bg-[#040261] text-lg text-white px-6 py-2 rounded"
          >
            Create User
          </button>
        </div>

      </div>

      {/* TABLE */}
      <div className="max-w-5xl mx-auto bg-white shadow mt-12 rounded-xl overflow-hidden">

        <div className="overflow-x-auto">
          <table className="w-full min-w-[700px]">

            <thead className="bg-[#030244] text-white text-xl">
              <tr>
                <th className="p-3 border text-center font-medium">Name</th>
                <th className="p-3 border text-center font-medium">Email</th>
                {/* <th className="p-3 border">Role</th> */}
                <th className="p-3 border text-center font-medium">Action</th>
              </tr>
            </thead>

            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center p-4 text-xl">
                    No Users Found
                  </td>
                </tr>
              ) : (
                users.map((u) => (
                  <tr key={u.user_id} className="border-b text-lg">

                    <td className="p-3 border text-center text-gray-700">{u.name}</td>
                    <td className="p-3 border text-center text-gray-700">{u.email}</td>

                    {/* <td className="p-3 border text-center">
                      <span className="bg-[#030244] text-white px-4 py-1.5 rounded">
                        {u.role}
                      </span>
                    </td> */}

                    <td className="p-3 border text-center">
                      
                      {/* ✅ ONLY SUPER ADMIN CAN SEE BUTTON */}
                      {loggedInUser?.role === "super_admin" ? (
                        <button
                          onClick={() => remove(u.user_id)}
                          className="bg-red-600 text-white px-3 py-1 rounded"
                        >
                          Delete
                        </button>
                      ) : (
                        <span className="text-gray-600 italic">
                          No Access
                        </span>
                      )}

                    </td>

                  </tr>
                ))
              )}
            </tbody>

          </table>
        </div>

      </div>

    </div>
  );
}